import React, { Component } from "react";
import { TimelineMax, Back } from "gsap";
import DevIcons from "./DevIcons";

class WorkItem extends Component {
  componentDidMount() {
    this.tl = new TimelineMax({ delay: 0, ease: Back.easeOut, paused: true });
  }

  enterTransition = time => {
    this.tl.fromTo(
      this.component,
      time,
      { opacity: 0 },
      { opacity: 1, delay: 0.2 }
    );
    this.tl.play();
  };

  exitTransition = time => {
    this.tl.fromTo(
      this.component,
      time,
      { opacity: 1 },
      { transform: "translateX(-70px)", opacity: 0 }
    );
    this.tl.play();
  };

  render = () => {
    return (
      <div className="section work" ref={c => (this.component = c)}>
        <div className="workInfo">
          <div className="workImage">
            <img src={this.props.image} alt="project" />
          </div>
          <div className="title">{this.props.title}</div>
          <div className="description">{this.props.description}</div>
          <DevIcons iconList={this.props.iconList} />
        </div>
      </div>
    );
  };
}

export default WorkItem;



// WEBPACK FOOTER //
// ./src/components/Work/WorkItem.js